export default "__VITE_ASSET__fdb3c551__"